<template>
    <div class="hcd-frame">
        <div class="menus">
            <div class="title">
                麦芒金聚合平台管理
            </div>
            <ul>
                <li class="menu" :class="{active : currentMenuPath === item.aPath}"  v-for="(item,index) in menus" :key="index" @click="goto(item)">
                   <i class="el-icon-s-home"></i><span style="margin-left: 8px;">{{  item.meta.title }}</span>
                </li>
            </ul>
        </div>
        <div class="container">
          <div class="header">
            <el-popover
              ref="popover"
              popper-class="user-popover"
              placement="bottom"
              width="200"
              trigger="click"
            >
              <div class="user" slot="reference">
                <img :src="defaultAvater"/>
                <span class="name">{{ username }}</span>
                <i class="el-icon-caret-bottom"></i>
              </div>
              <ul class="user-menus" @click="handlePopover">
                <li class="user-menu" @click="openPasswordDialog">修改密码</li>
                <li class="user-menu" @click="handleLogout">退出登录</li>
              </ul>

            </el-popover>

          </div>
          <div class="content">
            <router-view />
          </div>
        </div>
        <el-dialog append-to-body width="500px" title="修改密码" :visible.sync="passwordDialogVisible">
           <el-form ref="form" label-width="100px" :model="formData">
              <el-form-item label="绑定手机号" >
                <el-input disabled v-model="formData.phone" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code" :rules="[{required: true, message: '请输入短信验证码'}]">
                <el-input v-model="formData.code"  style="width: 180px">
                </el-input>
                <el-button :disabled="smsBtnDisabled" style="margin-left: 20px;width: 100px" @click="sendSmsCode">
                   {{ smsText }}
                </el-button>
              </el-form-item>
              <el-form-item label="新密码" prop="password" :rules="[{required: true, message: '请输入新密码'}]">
                <el-input style="width: 300px" auto-complete="off" type="password" v-model="formData.password"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="repassword" :rules="[{required: true, message: '请输入新密码'}, {validator: validatePass}]">
                <el-input style="width: 300px" auto-complete="off" type="password" v-model="formData.repassword"></el-input>
              </el-form-item>
           </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="passwordDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleChangePassword">修改密码</el-button>
          </span>
        </el-dialog>
        <el-dialog append-to-body width="500px" :title="passwordDialogTitle" :visible.sync="passwordDialogVisible">
           <el-form ref="form" label-width="100px" :model="formData">
              <el-form-item v-if="passwordDialogTip" label-width="0px">
                 <span style="margin-left: 10px">{{ passwordDialogTip }}</span>
              </el-form-item>
              <el-form-item label="绑定手机号" >
                <el-input disabled v-model="formData.phone" style="width: 300px"></el-input>
              </el-form-item>
              <el-form-item label="验证码" prop="code" :rules="[{required: true, message: '请输入短信验证码'}]">
                <el-input v-model="formData.code"  style="width: 180px">
                </el-input>
                <el-button :disabled="smsBtnDisabled" style="margin-left: 20px;width: 100px" @click="sendSmsCode">
                   {{ smsText }}
                </el-button>
              </el-form-item>
              <el-form-item label="新密码" prop="password" :rules="[{required: true, message: '请输入新密码'}]">
                <el-input style="width: 300px" auto-complete="off" type="password" v-model="formData.password"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码" prop="repassword" :rules="[{required: true, message: '请输入新密码'}, {validator: validatePass}]">
                <el-input style="width: 300px" auto-complete="off" type="password" v-model="formData.repassword"></el-input>
              </el-form-item>
           </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="passwordDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleChangePassword">修改密码</el-button>
          </span>
        </el-dialog>
    </div>
</template>

<script>
import defaultAvater from '@/web/assets/images/avater.png'
import { routerList } from '@/web/router/router.main.js'
export default {
  data () {
    const validatePass = (rule, value, callback) => {
      if (value !== this.formData.password) {
        callback(new Error('二次输入的密码不相同'))
      } else {
        callback()
      }
    }
    return {
      validatePass,
      changedPassWord: window.localStorage.getItem('changedPassWord') || 0,
      username: window.localStorage.getItem('name'),
      defaultAvater,
      menus: [],
      currentMenuPath: window.location.hash.substring(1),
      formData: {
        password: null,
        repassword: null,
        phone: null,
        code: null
      },
      passwordDialogVisible: false,
      smsText: '发送验证码',
      smsBtnDisabled: false,
      passwordDialogTitle: '修改密码',
      passwordDialogTip: '为了保证你的账号安全，请先修改默认登录密码'
    }
  },
  beforeCreate () {
    this.$router.beforeEach((to, form, next) => {
      this.currentMenuPath = to.path
      next()
    })
  },
  mounted () {
    // 获取后端返回的菜单数据
    const userMenusStr = localStorage.getItem('userMenus')
    const userInfoStr = localStorage.getItem('userInfo')
    
    console.log('🔍 详细调试信息:')
    console.log('localStorage中的userMenus原始数据:', userMenusStr)
    console.log('localStorage中的userInfo原始数据:', userInfoStr)
    
    const userMenus = userMenusStr ? JSON.parse(userMenusStr) : []
    const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
    
    console.log('解析后的菜单列表:', userMenus)
    console.log('解析后的用户信息:', userInfo)
    console.log('菜单数组长度:', userMenus.length)
    
    // 检查是否为超级管理员
    const isAdmin = userInfo.roleCode === 'SUPER_ADMIN' || userInfo.username === 'admin'
    console.log('是否为管理员:', isAdmin)
    
    // 如果没有菜单数据，或者是超级管理员，使用权限方式（兜底）
    if (!userMenus || userMenus.length === 0 || isAdmin) {
      console.log('⚠️ 没有菜单数据或超级管理员，使用权限方式兜底')
      const permission = this.getPermissionList()
      console.log('权限列表:', permission)
      
      // 超级管理员显示所有菜单，普通用户根据权限显示
      this.menus = routerList.filter(row => {
        if (isAdmin) {
          console.log(`✅ 超级管理员，添加菜单: ${row.meta.title}`)
          return true
        }
        
        const menuCode = row.meta.code
        const menuPermissionMap = {
          'customer:advisory:page': ['customer:advisory', 'customer:advisory:page'],
          'customer:apply:customer:page': ['customer:apply', 'customer:apply:customer:page'],
          'data:page': ['data', 'data:page'],
          'channel:provider:page': ['channel:provider', 'channel:provider:page'],
          'rule:page': ['rule', 'rule:page'],
          'user:page:list': ['user', 'user:page:list'],
          'role:page': ['permission', 'role:page'],
          'channel:page:template': ['channel:page:template', 'channel:page:template:list']
        }
        
        const requiredPermissions = menuPermissionMap[menuCode] || [menuCode]
        const hasPermission = requiredPermissions.some(perm => permission.includes(perm))
        console.log(`检查菜单权限: ${row.meta.title} (${menuCode}) -> ${hasPermission}`)
        return hasPermission
      })
      
      console.log('权限方式生成的菜单:', this.menus.map(m => m.meta.title))
    } else {
      // 从后端菜单中筛选出顶级菜单（parentId为0的菜单）
      const topLevelMenus = userMenus.filter(menu => menu.parentId === 0)
      console.log('顶级菜单:', topLevelMenus)
      console.log('顶级菜单数量:', topLevelMenus.length)
      
      // 将后端菜单映射到前端路由 - 支持多种可能的菜单名称
      const menuRouteMap = {
        // 客户咨询相关
        '客户咨询': '/consultation',
        '咨询管理': '/consultation',
        '咨询': '/consultation',
        
        // 客户申请相关  
        '客户申请': '/apply',
        '申请管理': '/apply',
        '申请': '/apply',
        
        // 数据报表相关
        '数据报表': '/report',
        '报表管理': '/report', 
        '报表': '/report',
        '统计报表': '/report',
        
        // 渠道管理相关
        '渠道管理': '/coop',
        '合作管理': '/coop',
        '渠道': '/coop',
        
        // 分配规则相关
        '分配规则': '/rule',
        '规则管理': '/rule',
        '规则': '/rule',
        
        // 成员管理相关
        '成员管理': '/member',
        '用户管理': '/member',
        '人员管理': '/member',
        '成员': '/member',
        
        // 权限管理相关
        '权限管理': '/privilege',
        '权限': '/privilege',
        '角色管理': '/privilege',
        
        // 模板配置相关
        '落地页模板配置': '/template-config',
        '模板配置': '/template-config',
        '页面配置': '/template-config',
        '模板管理': '/template-config'
      }
      
      console.log('菜单路由映射表:', menuRouteMap)
      console.log('可用的路由列表:', routerList.map(r => ({ path: r.path, title: r.meta.title })))
      
      // 根据后端菜单生成前端菜单
      this.menus = []
      
      topLevelMenus.forEach(menu => {
        console.log(`🔄 处理菜单: "${menu.title}"`)
        let routePath = menuRouteMap[menu.title]
        console.log(`直接映射结果: ${routePath}`)
        
        // 如果直接映射失败，尝试模糊匹配
        if (!routePath) {
          console.log(`❌ 直接映射失败，尝试模糊匹配...`)
          
          // 尝试包含匹配
          const menuKeys = Object.keys(menuRouteMap)
          for (let key of menuKeys) {
            if (key.includes(menu.title) || menu.title.includes(key)) {
              routePath = menuRouteMap[key]
              console.log(`🔍 模糊匹配成功: "${menu.title}" 匹配到 "${key}" -> ${routePath}`)
              break
            }
          }
          
          // 尝试去掉"管理"后缀匹配
          if (!routePath) {
            const titleWithoutManage = menu.title.replace(/管理$/, '')
            if (menuRouteMap[titleWithoutManage]) {
              routePath = menuRouteMap[titleWithoutManage]
              console.log(`🔍 去掉"管理"后匹配成功: "${menu.title}" -> "${titleWithoutManage}" -> ${routePath}`)
            }
          }
        }
        
        if (routePath) {
          // 在routerList中找到对应的路由配置
          const routeConfig = routerList.find(route => route.path === routePath)
          console.log(`查找路由配置: ${routePath}`, routeConfig ? '✅找到' : '❌未找到')
          
          if (routeConfig) {
            // 添加aPath属性用于导航
            const menuItem = {
              ...routeConfig,
              aPath: routePath,
              backendMenu: menu // 保存后端菜单信息
            }
            this.menus.push(menuItem)
            console.log(`✅ 成功添加菜单: "${menu.title}" -> ${routePath}`)
          } else {
            console.log(`⚠️ 未找到路由配置: "${menu.title}" -> ${routePath}`)
          }
        } else {
          console.log(`❌ 完全无法映射的菜单: "${menu.title}"`)
          console.log(`💡 提示: 请检查后端菜单名称是否正确，或在menuRouteMap中添加对应映射`)
        }
      })
    }
    
    console.log('✅ 最终显示的菜单数量:', this.menus.length)
    console.log('✅ 最终显示的菜单:', this.menus.map(m => ({ title: m.meta?.title, path: m.aPath || m.path })))
    
    // 如果还是没有菜单，强制显示基本菜单
    if (this.menus.length === 0) {
      console.log('🚨 没有任何菜单，强制显示基本菜单')
      this.menus = [
        {
          path: '/consultation',
          aPath: '/consultation',
          meta: { title: '客户咨询', name: 'consultation', code: 'customer:advisory:page' },
          component: () => import('@/web/views/consultation.vue')
        }
      ]
    }
    
    if (this.menus.length > 0 && this.$route.path === '/') {
      const firstMenuPath = this.menus[0].aPath || this.menus[0].path
      console.log('导航到第一个菜单:', firstMenuPath)
      this.$router.replace(firstMenuPath)
    }
    
    if (!parseInt(this.changedPassWord)) {
      this.openPasswordDialog(true)
    }
  },
  methods: {
    goto (item) {
      this.$router.push({ path: item.aPath })
    },
    handlePopover () {
      this.$refs.popover.doClose()
    },
    async handleLogout () {
      window.localStorage.clear()
      await this.$axios.post('/user/loginOut')
      this.$router.push({ path: '/login' })
    },
    openPasswordDialog (isFirst) {
      if (isFirst === true) {
        this.passwordDialogTitle = '修改密码提醒'
        this.passwordDialogTip = '为了保证你的账号安全，请先修改默认登录密码'
      } else {
        this.passwordDialogTitle = '修改密码'
        this.passwordDialogTip = ''
      }
      this.formData.phone = window.localStorage.getItem('phone')
      this.formData.code = null
      this.formData.password = null
      this.formData.repassword = null
      this.smsText = '发送验证码'
      clearInterval(this.smsTimer)
      this.smsTimer = null
      this.smsBtnDisabled = false
      this.passwordDialogVisible = true
    },
    async handleChangePassword () {
      await this.$refs.form.validate()
      await this.$axios.post('/sms/validCode', { biz: 'modify', phone: this.formData.phone, code: this.formData.code })
      await this.$axios.put('/user/init/password', { password: this.formData.password })
      this.$message.success('修改成功')
      this.passwordDialogVisible = false
    },
    async sendSmsCode () {
      this.$axios.post('/sms/getIdentifyingCode', { biz: 'modify', phone: this.formData.phone })
      this.smsText = 60
      this.smsBtnDisabled = true
      this.smsTimer = setInterval(() => {
        this.smsText--
        if (this.smsText === 0) {
          clearInterval(this.smsTimer)
          this.smsBtnDisabled = false
          this.smsText = '发送验证码'
        }
      }, 1000)
    },
    
    // 获取用户权限列表
    getPermissionList () {
      try {
        const permissions = localStorage.getItem('permissions')
        if (permissions) {
          const permissionList = JSON.parse(permissions)
          console.log('从localStorage获取的权限:', permissionList)
          return Array.isArray(permissionList) ? permissionList : []
        }
        
        // 如果没有权限数据，尝试从用户信息中获取
        const userInfo = localStorage.getItem('userInfo')
        if (userInfo) {
          const user = JSON.parse(userInfo)
          console.log('从userInfo获取权限:', user.permissions)
          return user.permissions || []
        }
        
        console.log('没有找到权限数据，返回空数组')
        return []
      } catch (error) {
        console.error('获取权限列表失败:', error)
        return []
      }
    }
  }

}
</script>

<style scoped lang="less">
.hcd-frame {
    display: flex;
    flex-direction: row;
    background-color: #F9F9F9;
    height: 100%;
  .menus {
    flex: 0 0 200px;
    background-color: #222944;
    color: #fff;
    .title {
      color: #fff;
      font-size: 18px;
      text-align: center;
      height: 50px;
      line-height: 50px;
      background-color: #081240;
      margin-bottom: 10px;
    }
    .menu {
      height: 40px;
      padding: 0 20px;
      line-height: 40px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;
      &+.menu {
        margin-top: 10px;
      }
      &:hover {
        background-color: #4381FF;
      }
      &.active {
        background-color: #4381FF;
      }
    }
  }
  .container {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    width: 0;
    .header {
      flex: 0 0 50px;
      background-color: #fff;
      box-shadow: 0px 3px 6px 0px #ebebeb;
      display: flex;
      flex-direction: row;
      justify-content: right;
      align-items: center;
      padding: 0 20px;
      .user {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #808080;
        cursor: pointer;
        img {
          height: 32px;
          margin-right: 8px;
        }
        .name {
          margin-right: 8px;
        }
      }
    }
    .content {
      flex: 1 1 auto;
      margin: 20px;
      background-color: #fff;
      position: relative;
    }
  }

}

.sms-code-send {

}

</style>
